import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M45.552 20.375h8.693v25.183h25.183v8.693H54.245v25.183h-8.693V54.251H20.369v-8.693h25.183z" })
});
export default SvgPlus;
